import useBreadCrumb from "@/context/BreadCrumbContext";
import { useEffect } from "react";

const Help = () => {
	const { setBreadCrumb } = useBreadCrumb();
	useEffect(() => {
		setBreadCrumb({
			mainLabel: {
				label: "Help",
				link: "help",
			},
			currentLabel: "",
		});
	}, []);
	return (
		<div className="bg-white p-4 rounded-xl w-full h-[85vh]">
			{/* <div className="flex justify-between items-center mb-4 font-body">
				<h1 className="text-2xl font-semibold w-full md:w-auto mb-2 md:mb-0 font-heading">
					Help Center
				</h1>
			</div> */}
			<div className="h-[70vh] flex justify-center items-center ">
				<div className="text-center ">
					<div className="text-5xl font-bold mb-3">Help Center</div>
					<div className="text-3xl mb-4 font-semibold">Coming Soon</div>
					<a href="mailto:support@talentick.ai" className="text-xl font-normal">
						support@talentick.ai
					</a>
				</div>
			</div>
		</div>
	);
};

export default Help;
